import { atom } from 'jotai';

export const selectLanguageOpen = atom<boolean>(false);

export const openSelectLanguageToggle = atom(null, (get, set, by) =>
  set(selectLanguageOpen, (value) => !value)
);
